// removed by extract-text-webpack-plugin
module.exports = {"Partners_headerRow":"Partners__Partners_headerRow___3deaf","Partners_evenRow":"Partners__Partners_evenRow___2WUeb","Partners_oddRow":"Partners__Partners_oddRow___2YGBz","Partners_headerColumn":"Partners__Partners_headerColumn___3JIbz"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/treasury/payment-partners/components/Partners.css
// module id = 1011
// module chunks = 0